// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { NotificationDialog } from './notification-dialog'

const COMPONENT_ID = 'notificationDialog'

export const showNotificationDialog = () => addModal({ id: COMPONENT_ID })

export default {
  [COMPONENT_ID]: {
    Component: NotificationDialog,
  },
}
